import i18n from "@/i18n";

function getBrowserLocale() {
  // 1. Pegamos o idioma do navegador (suporta mais navegadores)
  const navigatorLang = navigator.language || 
                      navigator.userLanguage || 
                      navigator.browserLanguage || 
                      navigator.systemLanguage || 
                      'pt-BR';
  
  // 2. Debug: mostre no console qual idioma está sendo detectado
  console.log('Idioma do navegador detectado:', navigatorLang);

  // 3. Mapeamento mais abrangente para espanhol
  const esVariants = ['es', 'es-ES', 'es-MX', 'es-AR', 'es-CL', 'es-CO', 'es-PE', 'es-VE', 'es-EC', 'es-UY', 'es-PY'];
  
  if (esVariants.some(lang => navigatorLang.startsWith(lang))) {
    console.log('Mapeando para es-PY');
    return 'es-PY';
  }

  // 4. Para português (mantendo sua lógica original)
  if (navigatorLang.startsWith('pt')) {
    return 'pt-BR';
  }

  // 5. Fallback
  return 'pt-BR';
}

export default {
  namespaced: true,
  state: {
    currentLanguage: localStorage.getItem('locale') || getBrowserLocale(),
  },
  mutations: {
    setLanguage(state, language) {
      state.currentLanguage = language;
      localStorage.setItem('locale', language);
      i18n.global.locale = language; // Atualiza o i18n
    },
  },
  actions: {
    // Ação para definir baseado no usuário (sua lógica original)
    setLanguageBasedOnUser({ commit }, user) {
      try {
        if (user && user.estrangeiro !== undefined) {
          const language = user.estrangeiro ? 'pt-BR' : 'es-PY';
          commit('setLanguage', language);
        } else {
          console.error('Usuário inválido ou campo "estrangeiro" não definido.');
          // Fallback para idioma do navegador
          commit('setLanguage', getBrowserLocale());
        }
      } catch (error) {
        console.error('Erro ao definir o idioma:', error);
        commit('setLanguage', 'pt-BR'); // Fallback seguro
      }
    },
    
    // Nova ação para inicialização do idioma
    initializeLanguage({ commit }) {
      const savedLocale = localStorage.getItem('locale');
      const browserLocale = getBrowserLocale();
      commit('setLanguage', savedLocale || browserLocale);
    },
  },
  getters: {
    currentLanguage: (state) => state.currentLanguage,
    isPortuguese: (state) => state.currentLanguage === 'pt-BR',
    isSpanish: (state) => state.currentLanguage === 'es-PY',
  },
};